<template>
  <div class="phone-con">
    <div class="title-text">为了您的账号安全，请绑定手机号码</div>

    <van-form
        ref="form"
        label-align="left"
        label-width="100"
        @submit="bindPhoneSubmit"
    >
      <van-field
          name="mobileNumber"
          v-model="mobileNumber"
          clearable
          type="number"
          placeholder="请输入手机号码"
          :rules="[{required: true, message: '必填'}]"
      >
        <div class="area-btn" slot="label" @click="areaPopupShow=true"><span>{{ areaCodeText }}</span></div>
      </van-field>

      <van-field
          v-model="smsCode"
          center
          clearable
          maxLengrh="4"
          type="number"
          label="验证码"
          placeholder="请输入短信验证码"
          :rules="[{required: true, message: '必填'}]"
      >
        <van-button slot="button" native-type="button" size="mini" type="info"  :disabled="isSend" @click="useVerify">{{ btnText }}</van-button>
      </van-field>

      <div class="btn-con" style="padding: 16px;text-align: center;">
        <van-button style="width: 140px;margin-right: 20px;" native-type="button" type="default" size="small" @click="noSetPhone">取消</van-button>
        <van-button style="width: 140px;" size="small" type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>


    <van-popup
        id="phone-area-popup"
        get-container="#app"
        v-model="areaPopupShow"
        :closeable="true"
        :style="{ width: '88%' }"
    >
      <div class="area-con">
        <div class="item" v-for="(item, i) in areaCodeList" :key="i"
             :class="{active: areaCode===item.telPrefix}" @click="selectArea(item)">
          <span class="tel">+{{ item.telPrefix }}</span>
          <span>({{ item.name }})</span>
        </div>
      </div>
    </van-popup>

    <Verify
        @success="success"
        :mode="'pop'"
        :captchaType="'clickWord'"
        :imgSize="{ width: '310px', height: '145.6px' }"
        ref="verify"
    />
  </div>
</template>

<script>
import Verify from "@/components/verifition/Verify";
import { wxBinPhone } from '@/api/login'
import { mapGetters } from 'vuex'
import {sendVerifyCode} from "@/api/mall/mallSystem";
export default {
  components: {
    Verify
  },
  computed: {
    ...mapGetters([
      'areaCodeData',
    ])
  },
  props: {
    canClose: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data(){
    return {
      areaCode: '86',
      areaCodeText: '+86 (中国)',
      areaCodeList: [],
      areaPopupShow: false,
      isSend: false,
      btnText: '发送验证码',
      time: 60,
      mobileNumber: '',
      smsCode: '',

      captchaVerification: ''
    }
  },
  watch:{
    areaCodeData(val){
      this.areaCodeList = val
    },
  },
  created(){
    this.$store.dispatch('app/changeAreaCodeData', { status: true })

  },
  methods: {
    useVerify(){
      this.$refs['form'].validate('mobileNumber').then(()=>{
        this.$refs.verify.show()
      })
    },
    success(params){
      console.log(params.captchaVerification)
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.captchaVerification = params.captchaVerification
      this.handlerGt()
    },


    timeDown(){
      let timer = window.setInterval(()=>{
        this.time--;
        this.btnText = '剩余 ' + this.time + ' 秒';
        if(this.time===0){
          window.clearInterval(timer);
          this.time = 60;
          this.btnText = '发送验证码';
          this.isSend = false
        }
      },1000)
    },
    handlerGt(){ //发送短信验证码
      this.$refs['form'].validate('mobileNumber').then(()=>{
        // this.captchaObj.verify();

        let phone = this.mobileNumber
        if(this.areaCode!=='86'){ // 处理区号
          phone = '+'+this.areaCode+'-'+phone
        }
        let req = {
          type: 'SMS',
          business: 'LOGIN',
          account: phone,
          captchaVerification: this.captchaVerification
        }
        sendVerifyCode(req).then(res=>{
          if (res.code === 200) {
            this.isSend = true;
            this.btnText = '剩余 ' + this.time + ' 秒';
            this.timeDown();
            this.$toast('验证码已发送，请查收短信！')
          } else if (res.code === 300) {
            this.$toast(res.message);
          } else {
            this.$toast(res.message);
          }
        })
      })
    },
    //处理国家地区区号数据
    selectArea(item){
      this.areaCode = item.telPrefix
      this.areaCodeText = '+' + item.telPrefix + ' (' + item.name + ')'
      this.areaPopupShow = false
    },

    noSetPhone(){
      if(this.canClose){ // 能够关闭弹窗
        this.$emit('closeBindPhone')
      }else { //返回上个页面
        this.$router.go(-1)
      }
    },
    //绑定手机
    bindPhoneSubmit(){
      this.$refs['form'].validate().then(()=>{
        let req = {
          mobileNumber: this.mobileNumber,
          smsCode: this.smsCode,
          openid: this.session('userOpenId'),
          wxCase: this.session('wxCase') || 1,
        };
        wxBinPhone(req).then(res=>{
          if(res.code===200){
            this.$emit('savePhone', 'ok')
          }else {
            this.$toast(res.message)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.phone-con{
  padding-top: 10px;
  .title-text{
    padding-top: 20px;
    font-size: 16px;color: #242424;
    line-height: 40px;text-align: center;
  }
  .phone-con{
    padding-top: 60px;
  }
  .area-btn{
    white-space: nowrap;margin-right: 8px;color: #666;
    line-height: 24px;padding-right: 10px;overflow: hidden;
  }
}
</style>
<style lang="less">
#phone-area-popup{
  border-radius: 12px;
  background-color: rgba(255,255,255,1);
  .area-con{
    margin-top: 40px;
    font-size: 14px;
    height: 50vh;overflow-y: auto;
    .item{
      padding: 10px 12px;
      border-bottom: 0.7px solid #f5f5f5;
      color: #747474;
      &.active{color: #00a6ff;}
      &:last-child{
        border-bottom: none;
      }
      .tel{display: inline-flex;min-width: 50px;}
    }
  }
}
</style>
